import { Spinner } from "../Spinner";

export const Button = props => {
  const {
    label,
    onClick,
    action = "black",
    type,
    disabled = false,
    className,
    loading = false,
    icon,
    customPadding,
    anchorType,
  } = props || {};

  const actions = {
    black: "border-transparent bg-black text-white lg:text-xs",
    primary: "border-transparent bg-blue-600 text-white hover:bg-blue-700 lg:text-xs",
    default: "border-gray-300 bg-white text-gray-700 hover:bg-gray-50 lg:text-xs",
    link: "border-none bg-white text-blue-800 lg:text-sm hover:bg-blue-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 lg:text-xs",
  };

  const disabledClass = disabled ? "opacity-50 cursor-not-allowed" : "";

  const actionClass = actions[action];

  const buttonProps = {
    // eslint-disable-next-line max-len
    type: type || "button",
    className: `${className || ""} inline-flex w-full items-center justify-center whitespace-nowrap rounded border shadow-sm ${customPadding || "px-4 py-2"} text-base font-medium capitalise focus:outline-none sm:w-auto sm:text-sm ${actionClass} ${disabledClass}`,
    ...(!disabled ? { onClick } : {}),
    disabled: disabled,
  };
  if (anchorType) {
    return (
      <a {...buttonProps}>
        {icon || null}
        {loading && <Spinner />}
        {label}
      </a>
    );
  }
  return (
    <button {...buttonProps}>
      {icon || null}
      {loading && <Spinner />}
      {label}
    </button>
  );
};
